<template>
  <div class="mask">
    <div class="examine-draft">
      <i class="close-icon iconfont iconguanbianniu2-copy" @click="onClose"></i>
      <div class="examine-title">指定成员审核您的草稿作品</div>
      <div class="examine-content">
        <div class="examine-h">
          <div>团队成员({{ memberList.length }})</div>
          <div class="examine-tips">仅可指定一位成员</div>
        </div>
        <div class="examine-members">
          <template v-for="(item, index) in memberList">
            <div class="members-item" v-if="memberList.length > 0" :key="index">
              <el-avatar
                size="small"
                :src="
                  item.cooperator.headImgUrl === null
                    ? require('../../assets/userCenter/defaulthead_bg.png')
                    : $handleAssetsUrl(item.cooperator.headImgUrl)
                "
                class="avatar-img"
              ></el-avatar>
              <div class="nickname">{{ item.cooperator.nickname }}</div>
              <!-- disabled -->
              <el-checkbox
                class="members-selection"
                v-model="item.selected"
                @change="onSelectItem(item)"
              ></el-checkbox>
            </div>
          </template>
          <div v-if="memberList.length === 0">团队内没有其他任何成员哦</div>
        </div>
      </div>
      <el-button
        class="btn confirm"
        type="primary"
        :disabled="isDisabled || !isSomeSelected"
        @click="onConfirm()"
        >确 定</el-button
      >
    </div>
    <el-dialog
      title="提示"
      :visible.sync="isExamineDialogVisible"
      width="464px"
      :modal="false"
      center
    >
      <div>
        提交审核将会把草稿转为协作草稿，你可以在
        <a href="/dashboard/team/cooperation" target="_blank">团队-协作草稿</a
        >中找到它。是否提交审核？
      </div>
      <div class="check">
        <el-checkbox v-model="checkboxValue"></el-checkbox>
        <span>之后不再提示</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="isExamineDialogVisible = false"
          >再想想</el-button
        >
        <el-button
          class="btn"
          type="primary"
          :disabled="isDisabled"
          @click="confirmSend()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import draft from "../../components/mixins/draft";

export default {
  mixins: [
    draft,
  ],
  data() {
    return {
      checkboxValue: true,
      isExamineDialogVisible: false,
      isDisabled: false,
      memberList: [],
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters([
      "UserMsg",
      'TopnavMsg',
      "teamMembers",
      "IsPrivateDraft",
      "cooperationDraftId",

    ]),
    isSomeSelected() {
      return this.memberList.some((v) => v.selected);
    }
  },
  methods: {
    ...mapActions([
      "fetchInviteCode",
      "fetchTeamMembers",
      "fetchJoinCooDraft",
      "removeCooperator",
      "fetchTeamCooTempList",
    ]),
    async init() {
      await this.fetchTeamMembers();
      // let id = this.getUuidInHash() || this.$route.projectId;
      let _userId = this.UserMsg.id;
      this.memberList = this.teamMembers.map((v) => {
        return {
          ...v,
          selected: false
        };
      });
      this.memberList = this.memberList.filter((item) => {
        return item.cooperatorId !== _userId;
      });
    },
    onSelectItem(item) {
      this.memberList.forEach((v) => {
        if (v.id !== item.id) {
          v.selected = false;
        }
      });
    },
    async onConfirm() {
      //  this.$store.commit('save_TopnavMsg', {
      //   isExamineMember: false
      // });
      if (!this.isSomeSelected) return;
      if (this.IsPrivateDraft) {
        const v = window.localStorage.getItem("examineDraft");
        if (v) {
          this.isDisabled = true;
          await this.runConfirmSend();
        } else {
          this.isExamineDialogVisible = true;
        }
      } else {
        await this.runConfirmSend();
      }
      
    },
    async confirmSend() {
      this.isDisabled = true;
      this.isExamineDialogVisible = false;
      if (this.checkboxValue) {
        const v = window.localStorage.setItem("examineDraft", 'true');
      }
      await this.runConfirmSend();
    },
    async runConfirmSend() {
      const reviewer = this.memberList.find((v) => v.selected);
      this.$bus.emit("examineDraftMember", reviewer.cooperatorId);
    },
    onClose() {
      this.$store.commit('save_TopnavMsg', {
        isExamineMember: false
      });
      this.$bus.emit("examineMemberCloase");
    },
  }
}
</script>
<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .check {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: right;
    align-items: center;
    .el-checkbox {
      margin-right: 8px;
    }
  }
  ::-webkit-scrollbar {
    width: 4px;
    height: 7px;
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ebecf2;
    opacity: 0.65;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    opacity: 0;
  }
}
.dialog-footer {
  .btn {
    width: 130px;
  }
}
.examine-draft {
  width: 446px;
  height: 492px;
  background: #ffffff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  position: relative;
  .confirm {
    margin: 25px auto 0;
    width: 116px;
    height: 36px;
    background: #6464f8;
    border-radius: 4px;
    color: #ffffff;
    // line-height: 36px;
    &.disabled {
      cursor: not-allowed;
      background-color: #f2f3f7;
      color: #272d4d;
    }
  }
  .examine-content {
    padding: 20px 32px 0;
    .examine-h {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      .examine-tips {
        color: #fa8c16;
      }
    }
    .examine-members {
      border-radius: 4px;
      border: 1px solid #ebecf2;
      height: 282px;
      overflow-y: scroll;
      padding: 20px 36px 8px 20px;
      .members-item {
        display: flex;
        align-items: center;
        height: 38px;
        line-height: 38px;
        position: relative;
        margin-bottom: 16px;
        .nickname {
          max-width: 230px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .members-selection {
          position: absolute;
          right: 0;
          //   width: 16px;
          //     height: 16px;
          //     border: 1px solid #6464F8;
          //     border-radius: 4px;
          //   .el-checkbox__input {
          //     .el-checkbox__inner {
          //       width: 20px;
          //       height: 20px;
          //       // border-radius: 14px;
          //       &::after {
          //         height: 11px;
          //         width: 5px;
          //         left: 6px;
          //         top: 1px;
          //       }
          //     }
          //   }
        }
        .avatar-img {
          width: 38px;
          height: 38px;
          border-radius: 4px;
          margin-right: 8px;
        }
      }
    }
  }
  .examine-title {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    color: #272d4d;
    padding: 30px 0 19px 36px;
    border-bottom: 1px solid #f2f3f7;
  }
  .close-icon {
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;
    transform: scale(1.4);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/popups/examineDraft.vue